import React from 'react';

const SuggestionsPanel = ({ pendingSuggestions, onAccept, onReject }) => {
  return (
    <div className="bg-dark-card/80 backdrop-blur-xl border border-orange-500/30 rounded-lg p-2 flex-shrink-0">
      <div className="flex items-center justify-between mb-2">
        <h3 className="text-xs font-semibold text-orange-200">Suggestions invités</h3>
        <span className="text-xs bg-orange-500/20 text-orange-300 px-1.5 py-0.5 rounded">
          {pendingSuggestions.length}
        </span>
      </div>
      {pendingSuggestions.length === 0 ? (
        <p className="text-xs text-orange-300/50 text-center py-4">Aucune suggestion</p>
      ) : (
        <div className="space-y-1 max-h-32 overflow-y-auto" style={{scrollbarWidth: 'thin'}}>
          {pendingSuggestions.slice(0, 4).map((suggestion) => (
            <div
              key={suggestion.id}
              className="p-1.5 bg-dark-input/30 rounded text-xs cursor-pointer hover:bg-slate-700/50 transition-colors"
              onClick={() => onAccept(suggestion.id)}
              title="Cliquez pour accepter"
            >
              <div className="font-medium truncate">{suggestion.requested_title || suggestion.title}</div>
              <div className="text-[10px] text-purple-300/70 truncate">par {suggestion.guest_name}</div>
              <div className="flex gap-1 mt-1">
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onAccept(suggestion.id);
                  }}
                  className="text-[10px] bg-green-600/20 hover:bg-green-600/40 text-green-300 px-2 py-0.5 rounded"
                >
                  ✓ Accepter
                </button>
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    onReject(suggestion.id);
                  }}
                  className="text-[10px] bg-red-600/20 hover:bg-red-600/40 text-red-300 px-2 py-0.5 rounded"
                >
                  ✗ Refuser
                </button>
              </div>
            </div>
          ))}
          {pendingSuggestions.length > 4 && (
            <div className="text-xs text-purple-300/70 text-center py-1">
              +{pendingSuggestions.length - 4} autres
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SuggestionsPanel;